import * as yup from 'yup'

export class InboundTripSendToBrokerTransporterDto {
  specialNotes?: string = undefined
  sentToBrokerDateTime?: string = undefined
}

export const inboundTripSendToBrokerTransporterValidationSchema = yup.object({
  specialNotes: yup.string().max(2_000, 'Special Notes cannot be more than 2,000 characters.').nullable()
})
